<template>
  <div class="user-form">
    <img class="logo" alt="ADRAYN" :src="$ComDomain.base + 'static/images/logo.png'">
    <h1><span>{{copyright.title}} &#8226; {{actions.login}}</span></h1>
    <div class="login-type bg-success" role="button" @click="changeLoginType">
      <Icon :type="loginByIc ? 'ios-lock' : 'md-phone-portrait'" :style="{lineHeight: loginByIc ? 1 : 1.2}" :size="loginByIc ? 50 : 45" />
    </div>
    <Form @submit.native.prevent>
      <div class="form-group">
        <Poptip v-model="mobileError" :content="warn.mobile" placement="bottom">
          <span :class="{'input-group-addon':1, 'text-primary':mobileFocus}" @click="mobileFocus=1"><Icon type="md-phone-portrait"></Icon> {{ userform.field.mobile }}</span>
          <AutoComplete @on-search="filterMobile" v-focus="mobileFocus" v-enter="()=>{passwordFocus=1}" @on-select="passwordFocus=1" @on-change="mobileError=false" @on-focus="mobileFocus=1" @on-blur="mobileFocus=0" v-model="user.mobile" :transfer="false" class="form-item" element-id="mobile">
            <Option v-for="item in mobileList" :value="item" :key="item">
              <Icon type="md-close" style="float:right;" @click="$store.commit('removeMobile', item)" />
              {{ item }}
            </Option>
          </AutoComplete>
        </Poptip>
      </div>
      <code-getter v-if="loginByIc" v-focus="codeFocus" @focus="codeFocus=1" @blur="codeFocus=0" process="login" ref="CodeGetter" :user="user" :mobileError="mobileError" @done="doLog" @validate="validateMobile"></code-getter>
      <div class="form-group" v-else>
        <Poptip v-model="passwordError" :content="warn.password" @click="passwordFocus=1" placement="right">
          <span :class="{'input-group-addon':1, 'text-primary':passwordFocus}" @click="passwordFocus=1"><Icon type="md-lock"></Icon> {{userform.field.password}}</span>
          <input v-focus="passwordFocus" @keypress.enter="doLog" @input="passwordError=false" @focus="passwordFocus=1" @blur="passwordFocus=0" v-model="user.password" maxlength="16" autocomplete="off" style="padding-left:75px" type="password" />
        </Poptip>
      </div>
      <div class="form-group">
        <a role="button" @click="$store.commit('userEnter', {action: 'forgot', mobile: user.mobile})" style="float:right;">{{userform.hint.password.forgot}}</a>
        <Checkbox v-model="autolog">{{ userform.login.auto }}</Checkbox>
      </div>
      <div class="form-group">
        <Button @click="doLog" shape="circle" type="success">{{ actions.login }}</Button>
      </div>
    </Form>
    <div style="text-align:center;margin-top:-4px">
      <a role="button" @click="$store.commit('userEnter', {action: 'reg'})">{{userform.login.reg}}</a>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { Icon, Button, Checkbox, Option, AutoComplete, Form } from 'iview'
import { values, actions, message, copyright, userform } from '../../locale'
import { validatePhone, validatePassword, vFocus, vEnter } from '../../utils'
import CodeGetter from '../CodeGetter'
import Poptip from './Poptip'

export default {
  name: 'Login',
  props: ['value'],
  data() {
    return {
      copyright,
      actions,
      userform,
      loginByIc: true,
      mobileFocus: 0,
      passwordFocus: 0,
      mobileError: false,
      passwordError: false,
      mobileList: [],
      codeFocus: 0,
      warn: {
        mobile: '',
        password: ''
      },
      user: {
        mobile: '',
        password: '',
        ic: ''
      }
    }
  },
  computed: {
    autolog: {
      get() {
        return window.localStorage.getItem('autolog') === 'true'
      },
      set(value) {
        window.localStorage.setItem('autolog', value)
      }
    },
    ...mapState(['mobileHistory'])
  },
  directives: {
    focus: vFocus,
    enter: vEnter
  },
  watch: {
    $route(to, from) {
      this.mobileError = this.passwordError = false
    },
    value() {
      this.setFocus()
    }
  },
  methods: {
    setFocus() {
      this[this.user.mobile ? (this.loginByIc ? 'codeFocus' : 'passwordFocus') : 'mobileFocus'] = this.value
    },
    changeLoginType() {
      this.loginByIc = !this.loginByIc
      this.$nextTick(() => {
        this.setFocus()
      })
    },
    filterMobile(value) {
      let mobiles = this.mobileHistory.filter(mobile => {
        return mobile.indexOf(value) !== -1
      })
      this.mobileList = mobiles.length ? mobiles : this.mobileHistory
    },
    validateMobile() {
      let result = validatePhone(this.user.mobile)
      this.user.mobile = result.correct
      this.warn.mobile = result.text
      this.mobileFocus = this.mobileError = result.error
      if (!result.error) return true
    },
    disLogin() {
      this.user[this.loginByIc ? 'password' : 'ic'] = null
      this.$store.dispatch('login', this.user)
        .then(() => {
          if (this.$route.params.to) {
            this.$router.push(this.$route.params.to)
          }
        })
        .catch((e) => {
          if (this.loginByIc) {
            this.$refs.CodeGetter.$emit('code-error', { type: 'wrong', target: userform.field.mobile + values.or + userform.field.code })
          } else {
            this.warn.password = message.content.wrong.replace('%', userform.field.mobile + values.or + userform.field.password)
            this.passwordFocus = this.passwordError = true
          }
        })
    },
    doLog() {
      if (!this.validateMobile()) {
        return
      }
      if (!this.loginByIc) {
        let result = validatePassword(this.user.password, true)
        this.warn.password = result.text
        this.passwordFocus = this.passwordError = result.error
        if (!result.error) this.disLogin()
      } else {
        this.$refs.CodeGetter.$emit('validate-then', () => {
          this.disLogin()
        })
      }
    }
  },
  created() {
    this.mobileList = this.mobileHistory
    this.user.mobile = this.mobileList[0]
  },
  components: {
    Icon,
    Button,
    Checkbox,
    Option,
    AutoComplete,
    CodeGetter,
    Form,
    Poptip
  }
}

</script>
<style lang="less">
.user-form {
  .login-type {
    width: 60px;
    height: 60px;
    position: absolute;
    top: 0;
    left: 0;

    i {
      color: #000;
    }

    &:before {
      content: "";
      display: block;
      border-top: 60px solid transparent;
      border-right: 60px solid #fff;
      position: absolute;
      right: 0;
      bottom: 0;
      z-index: 1;
    }

    &:hover i {
      color: #694404;
    }
  }

  .form-item input[type="text"] {
    padding-left: 80px;
  }
}
.mobile{
  .ivu-modal{
    min-width:9.3rem;
  }
  .user-form{
    padding:0.667rem 0.133rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/commons/components/login/Login.vue